import React, { Component } from "react";
import PropTypes from "prop-types";
import { service, actions } from "./log-data";
import { injectIntl, intlShape } from "@ai360/core/intl";
import { withCrud } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { messages } from "../i18n-messages";

export class CropLog_ extends Component {
    static propTypes = {
        records: PropTypes.array,
        intl: intlShape.isRequired,
    };
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.records) {
            for (const item of nextProps.records) {
                FormattingHelpers.formatLogDetailText(item);
            }
        }
    }
    render(): JSX.Element {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
            />
        );
    }
}
export const CropLog = injectIntl(withCrud(CropLog_, service, actions));
